import { Reducer } from 'redux'
import { Config } from '@chegg-wt/core/config'

import {
  setSbmLoaded,
  setAdzone,
  jwtInitialized,
  locationChange,
  setAdLayoutName,
  setUpdateMessagingFlag,
} from './actions'
import { ActionTypes } from './constants'
import { AppReducerState } from './types'

export type Action = ReturnType<
  | typeof setSbmLoaded
  | typeof setAdzone
  | typeof jwtInitialized
  | typeof locationChange
  | typeof setAdLayoutName
  | typeof setUpdateMessagingFlag
>

export const initialState: AppReducerState = {
  adzone: 'homepage',
  sbmLoaded: false,
  enableFolders: Config.enableFolders,
  initialized: false,
  currentRoute: null,
  adLayoutName: null,
  updateMessagingFlag: false,
}

export const AppReducer: Reducer<AppReducerState, Action> = (
  state: AppReducerState = initialState,
  action
) => {
  switch (action.type) {
    case ActionTypes.INITIALIZED: {
      return {
        ...state,
        initialized: true,
      }
    }
    case ActionTypes.SET_ADZONE:
      return {
        ...state,
        adzone: action.payload.adzone,
      }
    case ActionTypes.SET_AD_LAYOUT:
      return {
        ...state,
        adLayoutName: action.payload.adLayoutName,
      }
    case ActionTypes.SET_SBM_LOADED:
      return {
        ...state,
        sbmLoaded: action.payload.sbmLoaded,
      }
    case ActionTypes.LOCATION_CHANGE:
      return {
        ...state,
        currentRoute: action.payload.routeName,
      }
    case ActionTypes.SET_UPDATE_MESSAGING_FLAG:
      return {
        ...state,
        updateMessagingFlag: action.payload.updateMessagingFlag,
      }
    default:
      return state
  }
}

export default AppReducer
